import {
  COLLECTIONS_DELETE_COLLECTION_WORKFLOW_BEGIN,
  COLLECTIONS_DELETE_COLLECTION_WORKFLOW_SUCCESS,
  COLLECTIONS_DELETE_COLLECTION_WORKFLOW_FAILURE,
  COLLECTIONS_DELETE_COLLECTION_WORKFLOW_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function deleteCollectionWorkflow(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_COLLECTION_WORKFLOW_BEGIN,
    });
    const { projectId, version, workflowId, collectionUuid } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/workflows/${collectionUuid}/collection/${workflowId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_WORKFLOW_SUCCESS,
              data: res.data,
              collectionUuid,
            });
            Mixpanel.track('Deleted collection workflow');
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_WORKFLOW_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete collection workflow');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_COLLECTION_WORKFLOW_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete collection workflow');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCollectionWorkflowError() {
  return {
    type: COLLECTIONS_DELETE_COLLECTION_WORKFLOW_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_COLLECTION_WORKFLOW_BEGIN:
      return {
        ...state,
        deleteCollectionWorkflowPending: true,
        deleteCollectionWorkflowError: null,
      };

    case COLLECTIONS_DELETE_COLLECTION_WORKFLOW_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      if (projectCollections[index]) {
        projectCollections[index].workflows = action.data;
      }
      return {
        ...state,
        deleteCollectionWorkflowPending: false,
        deleteCollectionWorkflowError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          workflows: action.data,
        },
      };

    case COLLECTIONS_DELETE_COLLECTION_WORKFLOW_FAILURE:
      return {
        ...state,
        deleteCollectionWorkflowPending: false,
        deleteCollectionWorkflowError: action.data.error,
      };

    case COLLECTIONS_DELETE_COLLECTION_WORKFLOW_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteCollectionWorkflowError: null,
      };

    default:
      return state;
  }
}
